<template>
  <v-dialog
    :value="show"
    max-width="360px"
    class="dialog"
    @input="$emit('close')"
  >
    <v-card class="dialog__content">
      <v-date-picker
        v-model="dateRange"
        first-day-of-week="1"
        :locale="selectedLocale"
        :allowed-dates="disabledAfterToday"
        color="primary"
        no-title
        scrollable
        range
        class="date-picker"
      >
        <div class="custom-date">
          <div class="custom-date__fields">
            <v-text-field
              :value="dateRange[0]"
              :label="$t('message.common.dateFrom')"
              class="custom-date__field"
              disabled
            ></v-text-field
            ><v-text-field
              :value="dateRange[1]"
              :label="$t('message.common.dateTo')"
              class="custom-date__field"
              disabled
            ></v-text-field>
          </div>
        </div>
      </v-date-picker>
      <div class="dialog__actions">
        <ui-button color="primary" outlined @click="$emit('close')">
          {{ $t("message.common.cancel") }}
        </ui-button>

        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <ui-button color="primary" v-bind="attrs" v-on="on">
              {{ $t("message.common.exportToFile") }}
              <v-icon right>mdi-chevron-down</v-icon>
            </ui-button>
          </template>
          <v-list>
            <v-list-item @click="handleSubmit('csv')">
              <v-list-item-title>{{
                $t("message.common.csv")
              }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="handleSubmit('xlsx')">
              <v-list-item-title>{{
                $t("message.common.xlsx")
              }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import { FORMAT } from "@/config/date-format";

export default {
  name: "ReviewBoosterCalendarDialog",
  data() {
    return {
      show: true,
      dateRange: null
    };
  },
  computed: {
    selectedLocale() {
      return this.$store.state.settings.selectedLocale;
    }
  },
  created() {
    const date = moment();
    this.dateRange = [
      moment(date)
        .subtract(7, "days")
        .format(FORMAT.DATE),
      moment(date).format(FORMAT.DATE)
    ];
  },
  methods: {
    disabledAfterToday(val) {
      const currentDate = moment().format(FORMAT.DATE);
      const compareDate = moment(val);

      return compareDate.isSameOrBefore(currentDate);
    },
    handleSubmit(file_format = "csv") {
      this.$emit("change", { dateRange: this.dateRange, file_format });
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog {
  &__content {
    padding: $spacing * 3;
  }

  &__actions {
    display: flex;
    justify-content: space-between;
  }
}
.date-picker {
  display: flex;
  align-items: center;
}
::v-deep .v-date-picker {
  &-header {
    padding: 0;
  }
  &-table {
    padding: 0;
  }
}
::v-deep .v-dialog {
  border-radius: 25px;
}
::v-deep .v-picker {
  box-shadow: none !important;
  filter: none !important;
  padding: 0;

  &__body {
    margin: 0;
  }

  &__actions {
    padding: 0;
  }

  .custom-date {
    width: 100%;
    border-top: 1px solid $gray-200;
    padding-top: $spacing * 2;
    margin-top: $spacing * 2;

    &__fields {
      display: flex;
      align-items: center;
      gap: $spacing;
    }

    &__field {
      flex-grow: 1;
    }

    &__actions {
      display: flex;
      justify-content: space-between;
    }
  }
}
</style>
